import React from 'react';
import { Card, CardContent, Typography, CardActionArea } from '@mui/material';

const IngredientCard = ({ ingredient, onIngredientClick }) => {
  return (
    <Card sx={{ maxWidth: 345, margin: 1 }}>
      <CardActionArea onClick={() => onIngredientClick(ingredient)}>
        <CardContent>
          <Typography variant="h6">{ingredient.name}</Typography>
          <Typography variant="body2" color="text.secondary">
            Unit: {ingredient.measure_unit || 'N/A'}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Category: {ingredient.category || 'Uncategorized'}
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default IngredientCard;